import { armorAPI } from '~/services/api';

const fetchShippingOptions = () =>
  armorAPI.request({
    method: 'GET',
    url: `service-groups`,
  });

const updateShippingOption = (payload: unknown) =>
  armorAPI.request({
    data: payload,
    method: 'PUT',
    url: `service-groups`,
  });

const createShippingOption = (payload: unknown) =>
  armorAPI.request({
    data: payload,
    method: 'POST',
    url: `service-groups`,
  });

const deleteShippingOption = (id: string) =>
  armorAPI.request({
    method: 'DELETE',
    url: `service-groups/${id}/`,
  });

const getliveRatePackage = () =>
  armorAPI.request({
    method: 'GET',
    url: `live-rates/settings/parcel-template`,
  });

const updateLiveRatePackage = (payload: { object_id: string }) =>
  armorAPI.request({
    data: payload,
    method: 'PUT',
    url: `live-rates/settings/parcel-template`,
  });

const fetchLiveRateSenderAddress = () =>
  armorAPI.request({
    method: 'GET',
    url: `live-rates/settings/address`,
  });

const updateLiveRateSenderAddress = (liveRateAddressId: number) => {
  const payload = { live_rates_address_id: liveRateAddressId };
  return armorAPI.request({
    data: payload,
    method: 'PUT',
    url: `live-rates/settings/address`,
  });
};

export {
  createShippingOption,
  deleteShippingOption,
  fetchLiveRateSenderAddress,
  fetchShippingOptions,
  getliveRatePackage,
  updateLiveRatePackage,
  updateLiveRateSenderAddress,
  updateShippingOption,
};
